<main [class.full-screen]="this.isFullScreen">
    <div class="container-fluid site-width ssvmn-container position-relative" [class.full-screen]="this.isFullScreen">
        <!-- breadcrumbs -->
        <div class="row" *ngIf="this.isLargeSize && !this.isFullScreen">
            <div class="col-12">
                <div class="breadcrumbs-container d-flex align-items-center">
                   <div class="home-breadcrumb-container views-breadcrumb-container th-bg-white d-flex justify-content-center align-items-center cursor-pointer"
                        (click)="this.loadViewFromBreadcrumb(this.homeView)">
                        <i class="fa fa-home th-text-main fa-2x" aria-hidden="true" >
                    </i>
                   </div>
                   <div class="ms-2">
                    <i class="fa fa-angle-right th-text-main fa-2x"  
                        *ngIf="this.breadcrumbsData.length !== 0"
                        aria-hidden="true">
                    </i>
                   </div>
                   <div *ngFor="let view of this.breadcrumbsData; let breadcrumbsIndex=index" class="d-flex align-items-center cursor-pointer">
                        <div class="views-breadcrumb-container th-bg-white ms-2 d-flex justify-content-center align-items-center"
                             (click)="this.loadViewFromBreadcrumb(view)">
                            <span class="th-text-main bs-button">{{view}}</span>
                        </div>
                        <i class="fa fa-angle-right th-text-main fa-2x ms-2" aria-hidden="true" 
                            *ngIf="breadcrumbsIndex !== this.breadcrumbsData.length-1">
                        </i>
                   </div>
                </div>
            </div>
        </div>
        <div class="row-eq-height">
            <ng-container #target></ng-container>
        </div>
    </div>
</main>